import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_select, {
      modelValue: _ctx.selected,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
      label: _ctx.label,
      options: _ctx.options,
      placeholder: _ctx.$t('vueSelect.placeholder'),
      "reset-on-options-change": _ctx.resetOnOptionsChange,
      multiple: _ctx.multiple,
      clearable: _ctx.clearable,
      disabled: _ctx.disabled
    }, {
      "no-options": _withCtx(({ search, searching, loading }) => [
        _createTextVNode(_toDisplayString(_ctx.$t('vueSelect.noResults')), 1)
      ]),
      "open-indicator": _withCtx(({ attributes }) => [
        _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), null, 16),
        _createElementVNode("i", {
          class: _normalizeClass([_ctx.icon, "additional-p"])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["modelValue", "label", "options", "placeholder", "reset-on-options-change", "multiple", "clearable", "disabled"])
  ]))
}